export const mouseEventModifierKey = (eventInfo) => navigator.userAgent.includes("Mac") ? eventInfo.metaKey : eventInfo.ctrlKey;
export function mouseEventHasButtonPressed(eventInfo, button) {
    return (eventInfo.buttons & button) === button;
}
export var MouseEventButton;
(function (MouseEventButton) {
    MouseEventButton[MouseEventButton["LEFT"] = 0] = "LEFT";
    MouseEventButton[MouseEventButton["WHEEL"] = 1] = "WHEEL";
    MouseEventButton[MouseEventButton["RIGHT"] = 2] = "RIGHT";
    MouseEventButton[MouseEventButton["BACK"] = 3] = "BACK";
    MouseEventButton[MouseEventButton["FORWARD"] = 4] = "FORWARD";
})(MouseEventButton || (MouseEventButton = {}));
export var MouseEventButtons;
(function (MouseEventButtons) {
    MouseEventButtons[MouseEventButtons["LEFT"] = 1] = "LEFT";
    MouseEventButtons[MouseEventButtons["RIGHT"] = 2] = "RIGHT";
    MouseEventButtons[MouseEventButtons["WHEEL"] = 4] = "WHEEL";
    MouseEventButtons[MouseEventButtons["BACK"] = 8] = "BACK";
    MouseEventButtons[MouseEventButtons["FORWARD"] = 16] = "FORWARD";
})(MouseEventButtons || (MouseEventButtons = {}));
export function focusComposedPath() {
    const composedPath = [];
    let root = document;
    while (root && root.activeElement) {
        composedPath.push(root.activeElement);
        root = root.activeElement.shadowRoot;
    }
    return composedPath.reverse();
}
//# sourceMappingURL=helpers.js.map
